import baseAPI from '@/api';
import { DetailedBet } from '@/models/detailed-bet';
import { BetMoveDto } from '@/services/dto/bet/bet-move-input.dto';
import { AxiosResponse } from 'axios';

export async function fetchBetMove(data: BetMoveDto): Promise<DetailedBet> {
  const response: AxiosResponse<DetailedBet> = await baseAPI.patch<DetailedBet>(
    '/bets/originals/move',
    data,
  );

  return response.data;
}
